/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Info200ResponseDto } from '../models/info-200-response-dto';


/**
 * the ClaQueryInfo API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryInfoService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation info
   */
  static readonly InfoPath = '/system/claim';

  /**
   * Placeholder method for the initialzation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `info()` instead.
   *
   * This method doesn't expect any request body.
   */
  info$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Info200ResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryInfoService.InfoPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Info200ResponseDto>;
      })
    );
  }

  /**
   * Placeholder method for the initialzation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `info$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  info(params?: {
  },
  context?: HttpContext

): Observable<Info200ResponseDto> {

    return this.info$Response(params,context).pipe(
      map((r: StrictHttpResponse<Info200ResponseDto>) => r.body as Info200ResponseDto)
    );
  }

}
